import { DecimalPipe } from '@angular/common';
import { Component, input } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import { DictionaryCode } from '../../../enums/dictionary-code';

@Component({
  selector: 'app-fuel-tank-cell',
  imports: [TranslatePipe, DecimalPipe],
  templateUrl: './fuel-tank-cell.component.html',
  styleUrl: './fuel-tank-cell.component.scss',
})
export class FuelTankCellComponent {
  public readonly fuelType = input.required<string | null>();
  public readonly tankCapacity = input.required<number | null>();

  protected readonly DictionaryCode = DictionaryCode;
}
